import { CLEAR_CHECKOUT } from 'dux/checkout/actionTypes';
import {
  LOAD_CART_FAILURE,
  LOAD_CART_REQUEST,
  LOAD_CART_SUCCESS,
  UPDATE_CART_FAILURE,
  UPDATE_CART_MONOGRAM,
  UPDATE_CART_REQUEST,
  UPDATE_CART_SUCCESS,
} from 'dux/checkoutCart/actionTypes';

import { apiReducer } from 'utils/reduxUtils';

import initialState from './initialState';

const updateMonogram = (action, items) => {
  return items.map(item => {
    if (
      item.customization &&
      item.category === action.item.category &&
      item.product === action.item.product &&
      item.type === action.item.type
    ) {
      return {
        ...item,
        customization: {
          ...item.customization,
          monograms: action.monogram,
        },
      };
    }
    return item;
  });
};

export const cart = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_CHECKOUT:
      return {
        ...initialState,
      };
    case UPDATE_CART_REQUEST:
      return {
        ...state,
        status: 'saving',
        data: action.data,
        error: null,
      };
    case UPDATE_CART_SUCCESS:
      return {
        ...state,
        status: 'success',
        data: action.data,
      };
    case UPDATE_CART_FAILURE:
      return {
        ...state,
        status: 'success',
        data: action.data,
      };
    case UPDATE_CART_MONOGRAM:
      return {
        ...state,
        data: {
          ...state.data,
          items: updateMonogram(action, state.data.items),
          catalog: updateMonogram(action, state.data.catalog),
        },
      };
    default:
      return apiReducer([LOAD_CART_REQUEST, LOAD_CART_SUCCESS, LOAD_CART_FAILURE], state, action);
  }
};
